import { FeatureFlagDtoIn } from '@/models/in/FeatureFlagDtoIn';

/** Client-side table search for the management feature-flags board (SPR-1212). */
export function matchesFeatureFlagSearch(row: FeatureFlagDtoIn, query: string): boolean {
  const trimmed = query.trim();
  if (!trimmed) return true;
  const searchValue = trimmed.toLowerCase();
  return [row.displayName, row.featureKey, row.description, row.updatedByEmail]
    .some((field) => field?.toLowerCase().includes(searchValue));
}
